import Icon from 'component/Icon';
import React from 'react';

export default function Loading () {
  return (
    <div>
      <Icon type="iconlogin_loading" />
    </div>
  );
}
